module.exports = __webpack_public_path__ + "img/Lobby_Banner4.9f3b98e3.jpg";